import { PayloadAction } from "@reduxjs/toolkit";
import { all, call, put, takeLatest } from "redux-saga/effects";

import { commonMessages, ILocalizable } from "infrastructure/localization";
import { notification } from "infrastructure/notification";

import { mapParentRequest } from "../shared/helpers/ParentFlag.helper";

import { messagesActions } from "./Messages.actions";
import { messagesApi as api } from "./Messages.api";
import { IMessageItem, IMessagesFilter, IMessagesSearchQuery, IMessagesGetRequest } from "./Messages.state";

function* initializeExecute() {
  try {
    const [statuses, parents, displayTokens]: [ILocalizable[], ILocalizable[], boolean] = yield all([call(api.getMessagesStatuses), call(api.getParentOptions)]);

    const filter: IMessagesFilter = {
      statuses: statuses,
      parents: parents,
      displayTokens: displayTokens
    };

    yield put(messagesActions.initializeCompleted(filter));
  } catch (error) {
    yield put(messagesActions.loadingFailed(notification.error(error).useMessageId(commonMessages.error("searchFailed"))));
  }
}

function* searchExecute({ payload }: PayloadAction<IMessagesSearchQuery>) {
  try {
    if (payload) {
      const request: IMessagesGetRequest = {
        messageId: payload.messageId,
        text: payload.text,
        status: payload.selectedStatus,
        parent: mapParentRequest(payload.selectedParent)
      };
      const messages: IMessageItem[] = yield call(api.getMessages, request);

      yield put(messagesActions.searchMessagesCompleted(messages));
    }
  } catch (error) {
    yield put(messagesActions.loadingFailed(notification.error(error).useMessageId(commonMessages.error("searchFailed"))));
  }
}

function* downloadXmlTemplateExecute() {
  try {
    yield call(api.downloadXmlTemplate);
  } catch (error) {
    yield put(messagesActions.loadingFailed(notification.error(error).useMessageId(commonMessages.error("searchFailed"))));
  }
}

function* exportMessagesToXmlExecute({ payload }: PayloadAction<IMessagesSearchQuery>) {
  try {
    if (payload) {
      const request: IMessagesGetRequest = {
        messageId: payload.messageId,
        text: payload.text,
        status: payload.selectedStatus,
        parent: mapParentRequest(payload.selectedParent)
      };

      yield call(api.exportMessagesToXml, request);
    }
  } catch (error) {
    yield put(messagesActions.exportMessagesFailed(notification.error(error).useMessageId(commonMessages.error("exportFailed"))));
  }
}

function* actionWatcher() {
  yield takeLatest(messagesActions.initialize.toString(), initializeExecute);
  yield takeLatest(messagesActions.searchMessages.toString(), searchExecute);
  yield takeLatest(messagesActions.exportMessagesToXml.toString(), exportMessagesToXmlExecute);
  yield takeLatest(messagesActions.downloadMessagesUploadTemplate.toString(), downloadXmlTemplateExecute);
}

export function* messagesManagerSaga() {
  yield all([actionWatcher()]);
}
